import React from "react";
import { shallowEqual } from "react-redux";

import { useAppSelector, useAppDispatch } from "../../redux/hooks";
import swarzedzShifts from "../../data/swarzedzShifts";
import { dispatchCurrentShifts } from "../../redux/actions";

//* dispatch(getBuses()) ???
const UseShifts: React.VFC<{ configAgencyName: string }> = ({ configAgencyName }: { configAgencyName: string }): null => {
  const dispatch: Dispatch = useAppDispatch();
  const [currentServiceIdFromRedux, busesIds, sortedBlocksFromRedux]: [CurrentCalendar[], string[], string[]] =
    useAppSelector(
      (state: RootState) => [
        state?.constantValues?.currentCalendar,
        state?.constantValues?.busesIds,
        state?.blocksIdsList?.sortedBlocksIds,
      ],
      shallowEqual
    );

  const [currentServiceId, setCurrentServiceId] = React.useState<CurrentCalendar[]>();

  //^ Shifts
  const getCurrentShifts = React.useMemo((): { [key: string]: ObjectI } => {
    //@ Kombus Shits
    const shiftsKombusKornik: ObjectI =
      sortedBlocksFromRedux && Object.fromEntries(sortedBlocksFromRedux?.map((block: string) => [block, block]));
    const shiftsSrodaWlkp: ObjectI =
      sortedBlocksFromRedux && Object.fromEntries(sortedBlocksFromRedux?.map((block: string) => [block, block]));
    const shiftsKombusZTM: ObjectI =
      sortedBlocksFromRedux && Object.fromEntries(sortedBlocksFromRedux?.map((block: string) => [block, block]));
    //@ PKS Shits
    const shiftsPKS = {} as ObjectI;
    //@ PKS Shits
    const shiftsRokbus = {} as ObjectI;
    //@ TA Shits
    const shiftsTA_MDT = {} as ObjectI;
    const shiftsTA_COMB = {} as ObjectI;
    const shiftsTA_SW = {} as ObjectI;
    const shiftsTA_Doral = {} as ObjectI;
    const shiftsTA_MiamiSprings = {} as ObjectI;
    const shiftsTA_SmallCities = {} as ObjectI;
    const shiftsTA_FortLauderdale = {} as ObjectI;
    const shiftsTA_PompanoBeach = {} as ObjectI;
    const shiftsTA_BCT = {} as ObjectI;

    return {
      shiftsKombusKornik,
      shiftsSrodaWlkp,
      shiftsKombusZTM,
      shiftsPKS,
      shiftsTA_MDT,
      shiftsTA_COMB,
      shiftsTA_SW,
      shiftsTA_Doral,
      shiftsTA_MiamiSprings,
      shiftsTA_SmallCities,
      shiftsTA_FortLauderdale,
      shiftsRokbus,
      shiftsTA_PompanoBeach,
      shiftsTA_BCT,
    };
  }, [sortedBlocksFromRedux]);

  //* Set current serviceId
  React.useEffect(() => {
    if (currentServiceIdFromRedux) {
      setCurrentServiceId(currentServiceIdFromRedux);
    }
  }, [currentServiceIdFromRedux]);

  React.useEffect(() => {
    (async function (): Promise<void> {
      if (sortedBlocksFromRedux) {
        const {
          shiftsKombusKornik,
          shiftsSrodaWlkp,
          shiftsKombusZTM,
          shiftsPKS,
          shiftsTA_MDT,
          shiftsTA_COMB,
          shiftsTA_SW,
          shiftsTA_Doral,
          shiftsTA_MiamiSprings,
          shiftsTA_SmallCities,
          shiftsTA_FortLauderdale,
          shiftsRokbus,
          shiftsTA_PompanoBeach,
          shiftsTA_BCT,
        } = await getCurrentShifts;

        if (currentServiceId && busesIds) {
          if (configAgencyName === ("Swarzedz" as string)) {
            const currentCalendars: string[] = await currentServiceId
              ?.map((calendar) => calendar?.serviceId)
              .map((elem) => elem?.replaceAll("-", "_"))
              .map((str) => `shifts_${str}`);

            const currentShifts = [] as ObjectI[];
            for (let i = 0; i < currentCalendars?.length; i++) {
              for (let j = 0; j < swarzedzShifts?.length; j++) {
                if (currentCalendars[i] === Object?.keys(swarzedzShifts?.[j])?.[0]) {
                  currentShifts.push(Object?.values(swarzedzShifts?.[j])?.[0]);
                }
              }
            }
            // console.log("currentShifts:", currentShifts);
            const shiftsSwarzedz = Object.assign({}, ...currentShifts);
            // console.log("shiftsSwarzedz:", shiftsSwarzedz);
            await dispatch(dispatchCurrentShifts(shiftsSwarzedz));
          } else if (configAgencyName === ("kombusKornik" as string)) {
            await dispatch(dispatchCurrentShifts(shiftsKombusKornik));
          } else if (configAgencyName === ("kombusSroda" as string)) {
            await dispatch(dispatchCurrentShifts(shiftsSrodaWlkp));
          } else if (configAgencyName === ("kombusZTM" as string)) {
            await dispatch(dispatchCurrentShifts(shiftsKombusZTM));
          } else if (configAgencyName === ("PoznanPKS" as string)) {
            await dispatch(dispatchCurrentShifts(shiftsPKS));
          } else if (configAgencyName === ("MiamiDade" as string)) {
            await dispatch(dispatchCurrentShifts(shiftsTA_MDT));
          } else if (configAgencyName === ("MiamiBeach" as string)) {
            await dispatch(dispatchCurrentShifts(shiftsTA_COMB));
          } else if (configAgencyName === ("SweetWater" as string)) {
            await dispatch(dispatchCurrentShifts(shiftsTA_SW));
          } else if (configAgencyName === ("Doral" as string)) {
            await dispatch(dispatchCurrentShifts(shiftsTA_Doral));
          } else if (configAgencyName === ("MiamiSprings" as string)) {
            await dispatch(dispatchCurrentShifts(shiftsTA_MiamiSprings));
          } else if (configAgencyName === ("SmallCities" as string)) {
            await dispatch(dispatchCurrentShifts(shiftsTA_SmallCities));
          } else if (configAgencyName === ("FortLauderdale" as string)) {
            await dispatch(dispatchCurrentShifts(shiftsTA_FortLauderdale));
          } else if (configAgencyName === ("Rokbus" as string)) {
            await dispatch(dispatchCurrentShifts(shiftsRokbus));
          } else if (configAgencyName === ("PompanoBeach" as string)) {
            await dispatch(dispatchCurrentShifts(shiftsTA_PompanoBeach));
          } else if (configAgencyName === ("BCT" as string)) {
            await dispatch(dispatchCurrentShifts(shiftsTA_BCT));
          } else {
            await dispatch(dispatchCurrentShifts({}));
          }
        }
        // await dispatch(getBuses()); //* Temporally disabled
      }
    })();
  }, [configAgencyName, busesIds, currentServiceId, dispatch, getCurrentShifts, sortedBlocksFromRedux]);

  return null;
};

export default UseShifts;
